import { KnaufProject } from './knauf-project';
import { KnaufPalettes } from './knauf-palettes.enum';

export type KnaufProjectSet = { [k in KnaufPalettes]: KnaufProject[] };


const TopDesign: KnaufProject[] = [
  {
    layers: [
      //lewy zielony
      {
        color: { code: 'C 3481 PG III', rgb: '#8A9195' },
        selected: false, name: null, opacity: 80,
        cuts: [
          [
            { x: 223, y: 341 },
            { x: 223, y: 355 },
            { x: 247, y: 353 },
            { x: 248, y: 340 },
          ]
        ],

        points: [
          { x: 189, y: 341 },
          { x: 219, y: 340 },
          { x: 256, y: 340 },
          { x: 257, y: 358 },
          { x: 257, y: 424 },
          { x: 190, y: 421 },
        ]
      },

      //górny zielony lewy
      {
        color: { code: 'C 3481 PG III', rgb: '#8A9195' },
        selected: false, name: null, opacity: 80,
        cuts: [
        ],

        points: [
          { x: 259, y: 208 },
          { x: 325, y: 201 },
          { x: 324, y: 261 },
          { x: 258, y: 265 },
        ]
      },

      //górny zielony prawy
      {
        color: { code: 'C 3481 PG III', rgb: '#8A9195' },
        selected: false, name: null, opacity: 80,
        cuts: [
          [
            { x: 398, y: 196 },
            { x: 459, y: 191 },
            { x: 458, y: 253 },
            { x: 398, y: 258 },
          ], [
            { x: 481, y: 191 },
            { x: 517, y: 204 },
            { x: 516, y: 242 },
            { x: 517, y: 249 },
            { x: 486, y: 251 },
            { x: 483, y: 251 },
          ], [
            { x: 628, y: 201 },
            { x: 670, y: 198 },
            { x: 671, y: 255 },
            { x: 629, y: 258 },
          ], [
            { x: 693, y: 200 },
            { x: 705, y: 206 },
            { x: 705, y: 253 },
            { x: 693, y: 253 },
          ], [
            { x: 729, y: 213 },
            { x: 748, y: 211 },
            { x: 771, y: 225 },
            { x: 772, y: 271 },
            { x: 728, y: 260 },
          ]
        ],

        points: [
          { x: 387, y: 197 },
          { x: 472, y: 189 },
          { x: 543, y: 209 },
          { x: 688, y: 195 },
          { x: 727, y: 212 },
          { x: 748, y: 210 },
          { x: 817, y: 242 },
          { x: 818, y: 288 },
          { x: 712, y: 255 },
          { x: 618, y: 261 },
          { x: 555, y: 247 },
          { x: 386, y: 259 },
        ]
      },



      //glówna elewacja dół
      {
        color: { code: 'C 3494 PG II', rgb: '#E6EAE3' },
        selected: false, name: null, opacity: 80,
        cuts: [
          [
            { x: 325, y: 263 },
            { x: 387, y: 258 },
            { x: 386, y: 317 },
            { x: 325, y: 321 },
          ],
          [
            { x: 770, y: 333 },
            { x: 779, y: 334 },
            { x: 778, y: 391 },
            { x: 770, y: 391 },
          ],
          [
            { x: 804, y: 337 },
            { x: 812, y: 339 },
            { x: 811, y: 382 },
            { x: 819, y: 390 },
            { x: 804, y: 389 },
          ],
          [
            { x: 793, y: 231 },
            { x: 789, y: 422 },
            { x: 793, y: 421 },
            { x: 797, y: 234 },
          ]

        ],

        points: [
          { x: 258, y: 266 },
          { x: 554, y: 249 },
          { x: 621, y: 262 },
          { x: 713, y: 256 },
          { x: 819, y: 290 },
          { x: 818, y: 418 },
          { x: 714, y: 435 },
          { x: 671, y: 434 },
          { x: 673, y: 425 },
          { x: 713, y: 425 },
          { x: 748, y: 421 },
          { x: 747, y: 330 },
          { x: 712, y: 324 },
          { x: 622, y: 329 },
          { x: 551, y: 323 },
          { x: 551, y: 312 },
          { x: 387, y: 318 },
          { x: 324, y: 323 },
          { x: 323, y: 433 },
          { x: 258, y: 431 },
        ]
      },


      //głowna elewacja
      {
        color: { code: 'C 3494 PG II', rgb: '#E6EAE3' },
        selected: false, name: null, opacity: 80,
        cuts: [
          [
            { x: 313, y: 182 },
            { x: 313, y: 187 },
            { x: 325, y: 202 },
            { x: 385, y: 194 },
            { x: 387, y: 187 },
            { x: 371, y: 181 },
            { x: 330, y: 185 },
            { x: 329, y: 198 },
          ],
          [
            { x: 792, y: 226 },
            { x: 806, y: 220 },
            { x: 806, y: 212 },
            { x: 814, y: 213 },
            { x: 812, y: 223 },
            { x: 798, y: 229 },
          ]

        ],

        points: [
          { x: 206, y: 185 },
          { x: 467, y: 151 },
          { x: 555, y: 182 },
          { x: 738, y: 162 },
          { x: 849, y: 227 },
          { x: 849, y: 235 },
          { x: 820, y: 237 },
          { x: 819, y: 244 },
          { x: 750, y: 209 },
          { x: 728, y: 212 },
          { x: 688, y: 193 },
          { x: 544, y: 207 },
          { x: 471, y: 186 },
          { x: 258, y: 206 },
          { x: 209, y: 195 },
        ]
      },
      //komin lewy
      {
        color: { code: 'C 3442 PG II', rgb: '#B1B4B1' },
        selected: false, name: null, opacity: 80,
        cuts: [
          [
            { x: 386, y: 317 },
            { x: 331, y: 329 },
            { x: 332, y: 336 },
            { x: 386, y: 335 },

          ],
          [
            { x: 331, y: 162 },
            { x: 372, y: 152 },
            { x: 395, y: 142 },
            { x: 387, y: 185 },
            { x: 374, y: 182 },
            { x: 331, y: 187 },
          ]

        ],

        points: [
          { x: 330, y: 97 },
          { x: 371, y: 90 },
          { x: 396, y: 101 },
          { x: 395, y: 144 },
          { x: 387, y: 187 },
          { x: 387, y: 431 },
          { x: 372, y: 436 },
          { x: 330, y: 433 },
        ]
      },

      //komin prawy
      {
        color: { code: 'C 3442 PG II', rgb: '#B1B4B1' },
        selected: false, name: null, opacity: 80,
        cuts: [
        ],

        points: [
          { x: 654, y: 129 },
          { x: 699, y: 123 },
          { x: 707, y: 127 },
          { x: 708, y: 147 },
          { x: 654, y: 138 },
        ]
      },

      //wykonczenie lewe
      {
        color: { code: 'C 3442 PG II', rgb: '#B1B4B1' },
        selected: false, name: null, opacity: 80,
        cuts: [
        ],

        points: [
          { x: 589, y: 327 },
          { x: 621, y: 328 },
          { x: 621, y: 425 },
          { x: 594, y: 428 },
          { x: 588, y: 424 },
        ]
      },

      //wykonczenie prawe
      {
        color: { code: 'C 3442 PG II', rgb: '#B1B4B1' },
        selected: false, name: null, opacity: 80,
        cuts: [
        ],

        points: [
          { x: 672, y: 327 },
          { x: 712, y: 326 },
          { x: 748, y: 330 },
          { x: 748, y: 422 },
          { x: 712, y: 428 },
          { x: 672, y: 428 },
        ]
      },

    ],
    image: 'assets/domy/dom1_miejski_szyk.jpg'
  },
  {
    layers: [
      {
        color: { code: 'C 3222 PG III', rgb: '#C9D5DB' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          //lewo
          { x: 130, y: 372 },
          { x: 140, y: 371 },
          { x: 140, y: 443 },
          { x: 183, y: 444 },
          { x: 181, y: 359 },
          { x: 195, y: 354 },
          { x: 254, y: 357 },
          { x: 340, y: 342 },
          { x: 341, y: 507 },
          { x: 257, y: 497 },
          { x: 196, y: 500 },
          { x: 129, y: 489 },
        ]
      },
      {
        color: { code: 'C 3222 PG III', rgb: '#C9D5DB' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          //srodek
          { x: 348, y: 341 },
          { x: 360, y: 338 },
          { x: 425, y: 344 },
          { x: 426, y: 443 },
          { x: 545, y: 442 },
          { x: 545, y: 497 },
          { x: 359, y: 507 },
          { x: 348, y: 507 },

        ]
      },
      {
        color: { code: 'C 3222 PG III', rgb: '#C9D5DB' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          //prawo
          { x: 673, y: 379 },
          { x: 706, y: 376 },
          { x: 786, y: 383 },
          { x: 786, y: 392 },
          { x: 738, y: 390 },
          { x: 737, y: 445 },
          { x: 786, y: 445 },
          { x: 786, y: 382 },
          { x: 906, y: 391 },
          { x: 906, y: 495 },
          { x: 885, y: 495 },
          { x: 867, y: 496 },
          { x: 868, y: 395 },
          { x: 811, y: 395 },
          { x: 808, y: 480 },
          { x: 801, y: 477 },
          { x: 793, y: 476 },
          { x: 783, y: 475 },
          { x: 774, y: 475 },
          { x: 769, y: 482 },
          { x: 761, y: 488 },
          { x: 753, y: 492 },
          { x: 751, y: 503 },
          { x: 737, y: 503 },
          { x: 737, y: 496 },
          { x: 707, y: 496 },
          { x: 672, y: 493 },
        ],
      },
      // dom2 srodkowa elewacja
      {
        color: { code: '4020', rgb: '#F8CD4C' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          //lewo
          { x: 196, y: 330 },
          { x: 254, y: 336 },
          { x: 307, y: 321 },
          { x: 341, y: 338 },
          { x: 339, y: 344 },
          { x: 255, y: 358 },
          { x: 197, y: 355 },
          { x: 129, y: 373 },
        ]
      },
      {
        color: { code: '4020', rgb: '#F8CD4C' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          //srodek
          { x: 320, y: 321 },
          { x: 358, y: 310 },
          { x: 672, y: 342 },
          { x: 672, y: 363 },
          { x: 670, y: 372 },
          { x: 673, y: 381 },
          { x: 673, y: 491 },
          { x: 647, y: 493 },
          { x: 632, y: 493 },
          { x: 632, y: 362 },
          { x: 547, y: 360 },
          { x: 547, y: 353 },
          { x: 505, y: 353 },
          { x: 426, y: 349 },
          { x: 426, y: 343 },
          { x: 359, y: 338 },
          { x: 348, y: 341 },
          { x: 349, y: 333 },
        ]
      },
      // dom2 górna elewacja
      {
        color: { code: 'C 3480 PG III', rgb: '#768086' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 128, y: 353 },
          { x: 125, y: 346 },
          { x: 131, y: 341 },
          { x: 130, y: 331 },
          { x: 149, y: 285 },
          { x: 165, y: 309 },
          { x: 166, y: 323 },
          { x: 172, y: 321 },
          { x: 179, y: 331 },
          { x: 195, y: 331 },

        ]
      },
      {
        color: { code: 'C 3480 PG III', rgb: '#768086' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 568, y: 158 },
          { x: 640, y: 176 },
          { x: 665, y: 218 },
          { x: 664, y: 228 },
          { x: 672, y: 229 },
          { x: 676, y: 239 },
          { x: 676, y: 254 },
          { x: 628, y: 246 },
          { x: 629, y: 202 },
          { x: 561, y: 189 },
          { x: 559, y: 242 },
          { x: 521, y: 253 },
          { x: 521, y: 269 },
          { x: 511, y: 257 },
          { x: 511, y: 218 },
          { x: 526, y: 198 },
          { x: 544, y: 195 },
          { x: 546, y: 182 },
          { x: 537, y: 182 },

        ]
      },
      {
        color: { code: 'C 3480 PG III', rgb: '#768086' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 525, y: 257 },
          { x: 559, y: 248 },
          { x: 559, y: 298 },
          { x: 546, y: 301 },
          { x: 525, y: 277 },

        ]
      },
      {
        color: { code: 'C 3480 PG III', rgb: '#768086' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 636, y: 253 },
          { x: 674, y: 259 },
          { x: 675, y: 308 },
          { x: 636, y: 302 },

        ]
      },
    ],
    image: 'assets/domy/dom2_miejski_szyk.jpg'
  },
  {
    layers: [
      {
        color: { code: 'C 3503 PG III', rgb: '#E1EAE8' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 391, y: 88 },
          { x: 243, y: 326 },
          { x: 243, y: 373 },
          { x: 344, y: 365 },
          { x: 345, y: 251 },
          { x: 426, y: 237 },
          { x: 426, y: 357 },
          { x: 592, y: 343 },
          { x: 684, y: 361 },
          { x: 684, y: 313 },
          { x: 581, y: 285 },
        ]
      },
      {
        color: { code: 'C 3503 PG III', rgb: '#E1EAE8' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 843, y: 357 },
          { x: 844, y: 415 },
          { x: 798, y: 409 },
          { x: 798, y: 500 },
          { x: 886, y: 500 },
          { x: 886, y: 368 },

        ]
      },
      {
        color: { code: '4320', rgb: '#00729D' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 189, y: 485 },
          { x: 240, y: 485 },
          { x: 240, y: 491 },
          { x: 189, y: 491 },
        ],
      },
      {
        color: { code: '4320', rgb: '#00729D' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 737, y: 316 },
          { x: 737, y: 369 },
          { x: 776, y: 376 },
          { x: 776, y: 328 },
        ],
      },
      {
        color: { code: '4320', rgb: '#00729D' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 808, y: 337 },
          { x: 837, y: 345 },
          { x: 837, y: 388 },
          { x: 808, y: 382 },
        ],
      },
      {
        color: { code: '4830', rgb: '#4A5C54' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 192, y: 380 },
          { x: 192, y: 414 },
          { x: 240, y: 413 },
          { x: 240, y: 491 },
          { x: 192, y: 491 },
          { x: 192, y: 534 },
          { x: 220, y: 528 },
          { x: 302, y: 521 },
          { x: 302, y: 396 },
          { x: 592, y: 379 },
          { x: 843, y: 415 },
          { x: 843, y: 395 },
          { x: 592, y: 348 },

        ],
      },
      {
        color: { code: 'C 3503 PG III', rgb: '#E1EAE8' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 303, y: 397 },
          { x: 303, y: 520 },
          { x: 349, y: 519 },
          { x: 349, y: 400 },
          { x: 631, y: 385 },
          { x: 592, y: 379 },
        ],
      },
    ],
    image: 'assets/domy/dom3_miejski_szyk.jpg'
  },
  {
    layers: [
      //  dom4 jasnozielony lewy
      {
        color: { code: 'C 3543 PG II', rgb: '#E0EBE4' },
        selected: false, name: null, opacity: 80,
        cuts: [
          [
            { x: 211, y: 208 },
            { x: 274, y: 201 },
            { x: 272, y: 410 },
            { x: 213, y: 409 },
            { x: 213, y: 353 },
            { x: 210, y: 347 },
            { x: 207, y: 344 },
            { x: 208, y: 271 },
          ]
        ],
        points: [
          { x: 161, y: 155 },
          { x: 340, y: 127 },
          { x: 340, y: 180 },
          { x: 345, y: 183 },
          { x: 345, y: 376 },
          { x: 340, y: 378 },
          { x: 340, y: 458 },
          { x: 162, y: 453 },
        ]
      },

      //dom4 gora jasnozielony
      {
        color: { code: 'C 3543 PG II', rgb: '#E0EBE4' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 498, y: 239 },
          { x: 493, y: 239 },
          { x: 492, y: 174 },
          { x: 612, y: 162 },
          { x: 635, y: 174 },
          { x: 636, y: 112 },
          { x: 725, y: 182 },
          { x: 726, y: 232 },
          { x: 712, y: 223 },
          { x: 719, y: 222 },
          { x: 716, y: 220 },
          { x: 704, y: 222 },
          { x: 688, y: 215 },
          { x: 688, y: 250 },
          { x: 636, y: 254 },
          { x: 635, y: 242 },
          { x: 627, y: 237 },
          { x: 628, y: 176 },
          { x: 607, y: 168 },
          { x: 498, y: 178 },

        ]
      },

      //dom4 srodek bezowy
      {
        color: { code: '4830', rgb: '#4A5C54' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 340, y: 99 },
          { x: 467, y: 80 },
          { x: 511, y: 105 },
          { x: 492, y: 109 },
          { x: 494, y: 335 },
          { x: 520, y: 338 },
          { x: 521, y: 458 },
          { x: 484, y: 464 },
          { x: 483, y: 475 },
          { x: 467, y: 477 },
          { x: 429, y: 477 },
          { x: 427, y: 459 },
          { x: 418, y: 461 },
          { x: 418, y: 478 },
          { x: 341, y: 474 },
          { x: 340, y: 378 },
          { x: 427, y: 377 },
          { x: 425, y: 171 },
          { x: 340, y: 182 },

        ]
      },


      //dom4 dodatkowy bezowy
      {
        color: { code: '4830', rgb: '#4A5C54' },
        selected: false, name: null, opacity: 80,
        cuts: [
          [
            { x: 618, y: 365 },
            { x: 629, y: 365 },
            { x: 628, y: 374 },
            { x: 618, y: 374 },
          ],
          [
            { x: 619, y: 401 },
            { x: 628, y: 401 },
            { x: 620, y: 410 },
            { x: 619, y: 410 },
          ],
          [
            { x: 619, y: 435 },
            { x: 628, y: 435 },
            { x: 628, y: 446 },
            { x: 619, y: 446 },
          ]

        ],
        points: [
          { x: 608, y: 351 },
          { x: 642, y: 348 },
          { x: 644, y: 461 },
          { x: 607, y: 461 },
        ]
      },

      //dom4 bok brazowy
      {
        color: { code: 'C 3542 PG II', rgb: '#C7D3CE' },
        selected: false, name: null, opacity: 80,
        cuts: [],
        points: [
          { x: 543, y: 353 },
          { x: 544, y: 458 },
          { x: 520, y: 458 },
          { x: 520, y: 338 },
          { x: 602, y: 335 },
          { x: 610, y: 337 },
          { x: 636, y: 338 },
          { x: 635, y: 304 },
          { x: 816, y: 294 },
          { x: 853, y: 318 },
          { x: 854, y: 451 },
          { x: 855, y: 464 },
          { x: 819, y: 477 },
          { x: 807, y: 477 },
          { x: 805, y: 464 },
          { x: 814, y: 458 },
          { x: 805, y: 458 },
          { x: 801, y: 452 },
          { x: 798, y: 458 },
          { x: 795, y: 465 },
          { x: 773, y: 465 },
          { x: 773, y: 345 },
        ]
      },
    ],
    image: 'assets/domy/dom4_miejski_szyk.jpg'
  },
];

const MiejskiSzyk: KnaufProject[] = [
    {
        layers: [
            //lewy zielony
            {
                color: { code: 'C 3481 PG III', rgb: '#8A9195' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 223, y: 341 },
                        { x: 223, y: 355 },
                        { x: 247, y: 353 },
                        { x: 248, y: 340 },
                    ]
                ],

                points: [
                    { x: 189, y: 341 },
                    { x: 219, y: 340 },
                    { x: 256, y: 340 },
                    { x: 257, y: 358 },
                    { x: 257, y: 424 },
                    { x: 190, y: 421 },
                ]
            },

            //górny zielony lewy
            {
                color: { code: 'C 3481 PG III', rgb: '#8A9195' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 259, y: 208 },
                    { x: 325, y: 201 },
                    { x: 324, y: 261 },
                    { x: 258, y: 265 },
                ]
            },

            //górny zielony prawy
            {
                color: { code: 'C 3481 PG III', rgb: '#8A9195' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 398, y: 196 },
                        { x: 459, y: 191 },
                        { x: 458, y: 253 },
                        { x: 398, y: 258 },
                    ], [
                        { x: 481, y: 191 },
                        { x: 517, y: 204 },
                        { x: 516, y: 242 },
                        { x: 517, y: 249 },
                        { x: 486, y: 251 },
                        { x: 483, y: 251 },
                    ], [
                        { x: 628, y: 201 },
                        { x: 670, y: 198 },
                        { x: 671, y: 255 },
                        { x: 629, y: 258 },
                    ], [
                        { x: 693, y: 200 },
                        { x: 705, y: 206 },
                        { x: 705, y: 253 },
                        { x: 693, y: 253 },
                    ], [
                        { x: 729, y: 213 },
                        { x: 748, y: 211 },
                        { x: 771, y: 225 },
                        { x: 772, y: 271 },
                        { x: 728, y: 260 },
                    ]
                ],

                points: [
                    { x: 387, y: 197 },
                    { x: 472, y: 189 },
                    { x: 543, y: 209 },
                    { x: 688, y: 195 },
                    { x: 727, y: 212 },
                    { x: 748, y: 210 },
                    { x: 817, y: 242 },
                    { x: 818, y: 288 },
                    { x: 712, y: 255 },
                    { x: 618, y: 261 },
                    { x: 555, y: 247 },
                    { x: 386, y: 259 },
                ]
            },



            //glówna elewacja dół
            {
                color: { code: 'C 3494 PG II', rgb: '#E6EAE3' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 325, y: 263 },
                        { x: 387, y: 258 },
                        { x: 386, y: 317 },
                        { x: 325, y: 321 },
                    ],
                    [
                        { x: 770, y: 333 },
                        { x: 779, y: 334 },
                        { x: 778, y: 391 },
                        { x: 770, y: 391 },
                    ],
                    [
                        { x: 804, y: 337 },
                        { x: 812, y: 339 },
                        { x: 811, y: 382 },
                        { x: 819, y: 390 },
                        { x: 804, y: 389 },
                    ],
                    [
                        { x: 793, y: 231 },
                        { x: 789, y: 422 },
                        { x: 793, y: 421 },
                        { x: 797, y: 234 },
                    ]

                ],

                points: [
                    { x: 258, y: 266 },
                    { x: 554, y: 249 },
                    { x: 621, y: 262 },
                    { x: 713, y: 256 },
                    { x: 819, y: 290 },
                    { x: 818, y: 418 },
                    { x: 714, y: 435 },
                    { x: 671, y: 434 },
                    { x: 673, y: 425 },
                    { x: 713, y: 425 },
                    { x: 748, y: 421 },
                    { x: 747, y: 330 },
                    { x: 712, y: 324 },
                    { x: 622, y: 329 },
                    { x: 551, y: 323 },
                    { x: 551, y: 312 },
                    { x: 387, y: 318 },
                    { x: 324, y: 323 },
                    { x: 323, y: 433 },
                    { x: 258, y: 431 },
                ]
            },


            //głowna elewacja
            {
                color: { code: 'C 3494 PG II', rgb: '#E6EAE3' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 313, y: 182 },
                        { x: 313, y: 187 },
                        { x: 325, y: 202 },
                        { x: 385, y: 194 },
                        { x: 387, y: 187 },
                        { x: 371, y: 181 },
                        { x: 330, y: 185 },
                        { x: 329, y: 198 },
                    ],
                    [
                        { x: 792, y: 226 },
                        { x: 806, y: 220 },
                        { x: 806, y: 212 },
                        { x: 814, y: 213 },
                        { x: 812, y: 223 },
                        { x: 798, y: 229 },
                    ]

                ],

                points: [
                    { x: 206, y: 185 },
                    { x: 467, y: 151 },
                    { x: 555, y: 182 },
                    { x: 738, y: 162 },
                    { x: 849, y: 227 },
                    { x: 849, y: 235 },
                    { x: 820, y: 237 },
                    { x: 819, y: 244 },
                    { x: 750, y: 209 },
                    { x: 728, y: 212 },
                    { x: 688, y: 193 },
                    { x: 544, y: 207 },
                    { x: 471, y: 186 },
                    { x: 258, y: 206 },
                    { x: 209, y: 195 },
                ]
            },
            //komin lewy
            {
                color: { code: 'C 3442 PG II', rgb: '#B1B4B1' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 386, y: 317 },
                        { x: 331, y: 329 },
                        { x: 332, y: 336 },
                        { x: 386, y: 335 },

                    ],
                    [
                        { x: 331, y: 162 },
                        { x: 372, y: 152 },
                        { x: 395, y: 142 },
                        { x: 387, y: 185 },
                        { x: 374, y: 182 },
                        { x: 331, y: 187 },
                    ]

                ],

                points: [
                    { x: 330, y: 97 },
                    { x: 371, y: 90 },
                    { x: 396, y: 101 },
                    { x: 395, y: 144 },
                    { x: 387, y: 187 },
                    { x: 387, y: 431 },
                    { x: 372, y: 436 },
                    { x: 330, y: 433 },
                ]
            },

            //komin prawy
            {
                color: { code: 'C 3442 PG II', rgb: '#B1B4B1' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 654, y: 129 },
                    { x: 699, y: 123 },
                    { x: 707, y: 127 },
                    { x: 708, y: 147 },
                    { x: 654, y: 138 },
                ]
            },

            //wykonczenie lewe
            {
                color: { code: 'C 3442 PG II', rgb: '#B1B4B1' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 589, y: 327 },
                    { x: 621, y: 328 },
                    { x: 621, y: 425 },
                    { x: 594, y: 428 },
                    { x: 588, y: 424 },
                ]
            },

            //wykonczenie prawe
            {
                color: { code: 'C 3442 PG II', rgb: '#B1B4B1' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 672, y: 327 },
                    { x: 712, y: 326 },
                    { x: 748, y: 330 },
                    { x: 748, y: 422 },
                    { x: 712, y: 428 },
                    { x: 672, y: 428 },
                ]
            },

        ],
        image: 'assets/domy/dom1_miejski_szyk.jpg'
    },
    {
        layers: [
            {
                color: { code: 'C 3222 PG III', rgb: '#C9D5DB' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //lewo
                    { x: 130, y: 372 },
                    { x: 140, y: 371 },
                    { x: 140, y: 443 },
                    { x: 183, y: 444 },
                    { x: 181, y: 359 },
                    { x: 195, y: 354 },
                    { x: 254, y: 357 },
                    { x: 340, y: 342 },
                    { x: 341, y: 507 },
                    { x: 257, y: 497 },
                    { x: 196, y: 500 },
                    { x: 129, y: 489 },
                ]
            },
            {
                color: { code: 'C 3222 PG III', rgb: '#C9D5DB' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //srodek
                    { x: 348, y: 341 },
                    { x: 360, y: 338 },
                    { x: 425, y: 344 },
                    { x: 426, y: 443 },
                    { x: 545, y: 442 },
                    { x: 545, y: 497 },
                    { x: 359, y: 507 },
                    { x: 348, y: 507 },

                ]
            },
            {
                color: { code: 'C 3222 PG III', rgb: '#C9D5DB' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //prawo
                    { x: 673, y: 379 },
                    { x: 706, y: 376 },
                    { x: 786, y: 383 },
                    { x: 786, y: 392 },
                    { x: 738, y: 390 },
                    { x: 737, y: 445 },
                    { x: 786, y: 445 },
                    { x: 786, y: 382 },
                    { x: 906, y: 391 },
                    { x: 906, y: 495 },
                    { x: 885, y: 495 },
                    { x: 867, y: 496 },
                    { x: 868, y: 395 },
                    { x: 811, y: 395 },
                    { x: 808, y: 480 },
                    { x: 801, y: 477 },
                    { x: 793, y: 476 },
                    { x: 783, y: 475 },
                    { x: 774, y: 475 },
                    { x: 769, y: 482 },
                    { x: 761, y: 488 },
                    { x: 753, y: 492 },
                    { x: 751, y: 503 },
                    { x: 737, y: 503 },
                    { x: 737, y: 496 },
                    { x: 707, y: 496 },
                    { x: 672, y: 493 },
                ],
            },
            // dom2 srodkowa elewacja
            {
                color: { code: '4020', rgb: '#F8CD4C' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //lewo
                    { x: 196, y: 330 },
                    { x: 254, y: 336 },
                    { x: 307, y: 321 },
                    { x: 341, y: 338 },
                    { x: 339, y: 344 },
                    { x: 255, y: 358 },
                    { x: 197, y: 355 },
                    { x: 129, y: 373 },
                ]
            },
            {
                color: { code: '4020', rgb: '#F8CD4C' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //srodek
                    { x: 320, y: 321 },
                    { x: 358, y: 310 },
                    { x: 672, y: 342 },
                    { x: 672, y: 363 },
                    { x: 670, y: 372 },
                    { x: 673, y: 381 },
                    { x: 673, y: 491 },
                    { x: 647, y: 493 },
                    { x: 632, y: 493 },
                    { x: 632, y: 362 },
                    { x: 547, y: 360 },
                    { x: 547, y: 353 },
                    { x: 505, y: 353 },
                    { x: 426, y: 349 },
                    { x: 426, y: 343 },
                    { x: 359, y: 338 },
                    { x: 348, y: 341 },
                    { x: 349, y: 333 },
                ]
            },
            // dom2 górna elewacja
            {
                color: { code: 'C 3480 PG III', rgb: '#768086' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 128, y: 353 },
                    { x: 125, y: 346 },
                    { x: 131, y: 341 },
                    { x: 130, y: 331 },
                    { x: 149, y: 285 },
                    { x: 165, y: 309 },
                    { x: 166, y: 323 },
                    { x: 172, y: 321 },
                    { x: 179, y: 331 },
                    { x: 195, y: 331 },

                ]
            },
            {
                color: { code: 'C 3480 PG III', rgb: '#768086' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 568, y: 158 },
                    { x: 640, y: 176 },
                    { x: 665, y: 218 },
                    { x: 664, y: 228 },
                    { x: 672, y: 229 },
                    { x: 676, y: 239 },
                    { x: 676, y: 254 },
                    { x: 628, y: 246 },
                    { x: 629, y: 202 },
                    { x: 561, y: 189 },
                    { x: 559, y: 242 },
                    { x: 521, y: 253 },
                    { x: 521, y: 269 },
                    { x: 511, y: 257 },
                    { x: 511, y: 218 },
                    { x: 526, y: 198 },
                    { x: 544, y: 195 },
                    { x: 546, y: 182 },
                    { x: 537, y: 182 },

                ]
            },
            {
                color: { code: 'C 3480 PG III', rgb: '#768086' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 525, y: 257 },
                    { x: 559, y: 248 },
                    { x: 559, y: 298 },
                    { x: 546, y: 301 },
                    { x: 525, y: 277 },

                ]
            },
            {
                color: { code: 'C 3480 PG III', rgb: '#768086' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 636, y: 253 },
                    { x: 674, y: 259 },
                    { x: 675, y: 308 },
                    { x: 636, y: 302 },

                ]
            },
        ],
        image: 'assets/domy/dom2_miejski_szyk.jpg'
    },
    {
        layers: [
            {
                color: { code: 'C 3503 PG III', rgb: '#E1EAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 391, y: 88 },
                    { x: 243, y: 326 },
                    { x: 243, y: 373 },
                    { x: 344, y: 365 },
                    { x: 345, y: 251 },
                    { x: 426, y: 237 },
                    { x: 426, y: 357 },
                    { x: 592, y: 343 },
                    { x: 684, y: 361 },
                    { x: 684, y: 313 },
                    { x: 581, y: 285 },
                ]
            },
            {
                color: { code: 'C 3503 PG III', rgb: '#E1EAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 843, y: 357 },
                    { x: 844, y: 415 },
                    { x: 798, y: 409 },
                    { x: 798, y: 500 },
                    { x: 886, y: 500 },
                    { x: 886, y: 368 },

                ]
            },
            {
                color: { code: '4320', rgb: '#00729D' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 189, y: 485 },
                    { x: 240, y: 485 },
                    { x: 240, y: 491 },
                    { x: 189, y: 491 },
                ],
            },
            {
                color: { code: '4320', rgb: '#00729D' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 737, y: 316 },
                    { x: 737, y: 369 },
                    { x: 776, y: 376 },
                    { x: 776, y: 328 },
                ],
            },
            {
                color: { code: '4320', rgb: '#00729D' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 808, y: 337 },
                    { x: 837, y: 345 },
                    { x: 837, y: 388 },
                    { x: 808, y: 382 },
                ],
            },
            {
                color: { code: '4830', rgb: '#4A5C54' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 192, y: 380 },
                    { x: 192, y: 414 },
                    { x: 240, y: 413 },
                    { x: 240, y: 491 },
                    { x: 192, y: 491 },
                    { x: 192, y: 534 },
                    { x: 220, y: 528 },
                    { x: 302, y: 521 },
                    { x: 302, y: 396 },
                    { x: 592, y: 379 },
                    { x: 843, y: 415 },
                    { x: 843, y: 395 },
                    { x: 592, y: 348 },

                ],
            },
            {
                color: { code: 'C 3503 PG III', rgb: '#E1EAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 303, y: 397 },
                    { x: 303, y: 520 },
                    { x: 349, y: 519 },
                    { x: 349, y: 400 },
                    { x: 631, y: 385 },
                    { x: 592, y: 379 },
                ],
            },
        ],
        image: 'assets/domy/dom3_miejski_szyk.jpg'
    },
    {
        layers: [
            //  dom4 jasnozielony lewy
            {
                color: { code: 'C 3543 PG II', rgb: '#E0EBE4' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 211, y: 208 },
                        { x: 274, y: 201 },
                        { x: 272, y: 410 },
                        { x: 213, y: 409 },
                        { x: 213, y: 353 },
                        { x: 210, y: 347 },
                        { x: 207, y: 344 },
                        { x: 208, y: 271 },
                    ]
                ],
                points: [
                    { x: 161, y: 155 },
                    { x: 340, y: 127 },
                    { x: 340, y: 180 },
                    { x: 345, y: 183 },
                    { x: 345, y: 376 },
                    { x: 340, y: 378 },
                    { x: 340, y: 458 },
                    { x: 162, y: 453 },
                ]
            },

            //dom4 gora jasnozielony
            {
                color: { code: 'C 3543 PG II', rgb: '#E0EBE4' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 498, y: 239 },
                    { x: 493, y: 239 },
                    { x: 492, y: 174 },
                    { x: 612, y: 162 },
                    { x: 635, y: 174 },
                    { x: 636, y: 112 },
                    { x: 725, y: 182 },
                    { x: 726, y: 232 },
                    { x: 712, y: 223 },
                    { x: 719, y: 222 },
                    { x: 716, y: 220 },
                    { x: 704, y: 222 },
                    { x: 688, y: 215 },
                    { x: 688, y: 250 },
                    { x: 636, y: 254 },
                    { x: 635, y: 242 },
                    { x: 627, y: 237 },
                    { x: 628, y: 176 },
                    { x: 607, y: 168 },
                    { x: 498, y: 178 },

                ]
            },

            //dom4 srodek bezowy
            {
                color: { code: '4830', rgb: '#4A5C54' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 340, y: 99 },
                    { x: 467, y: 80 },
                    { x: 511, y: 105 },
                    { x: 492, y: 109 },
                    { x: 494, y: 335 },
                    { x: 520, y: 338 },
                    { x: 521, y: 458 },
                    { x: 484, y: 464 },
                    { x: 483, y: 475 },
                    { x: 467, y: 477 },
                    { x: 429, y: 477 },
                    { x: 427, y: 459 },
                    { x: 418, y: 461 },
                    { x: 418, y: 478 },
                    { x: 341, y: 474 },
                    { x: 340, y: 378 },
                    { x: 427, y: 377 },
                    { x: 425, y: 171 },
                    { x: 340, y: 182 },

                ]
            },


            //dom4 dodatkowy bezowy
            {
                color: { code: '4830', rgb: '#4A5C54' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 618, y: 365 },
                        { x: 629, y: 365 },
                        { x: 628, y: 374 },
                        { x: 618, y: 374 },
                    ],
                    [
                        { x: 619, y: 401 },
                        { x: 628, y: 401 },
                        { x: 620, y: 410 },
                        { x: 619, y: 410 },
                    ],
                    [
                        { x: 619, y: 435 },
                        { x: 628, y: 435 },
                        { x: 628, y: 446 },
                        { x: 619, y: 446 },
                    ]

                ],
                points: [
                    { x: 608, y: 351 },
                    { x: 642, y: 348 },
                    { x: 644, y: 461 },
                    { x: 607, y: 461 },
                ]
            },

            //dom4 bok brazowy
            {
                color: { code: 'C 3542 PG II', rgb: '#C7D3CE' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 543, y: 353 },
                    { x: 544, y: 458 },
                    { x: 520, y: 458 },
                    { x: 520, y: 338 },
                    { x: 602, y: 335 },
                    { x: 610, y: 337 },
                    { x: 636, y: 338 },
                    { x: 635, y: 304 },
                    { x: 816, y: 294 },
                    { x: 853, y: 318 },
                    { x: 854, y: 451 },
                    { x: 855, y: 464 },
                    { x: 819, y: 477 },
                    { x: 807, y: 477 },
                    { x: 805, y: 464 },
                    { x: 814, y: 458 },
                    { x: 805, y: 458 },
                    { x: 801, y: 452 },
                    { x: 798, y: 458 },
                    { x: 795, y: 465 },
                    { x: 773, y: 465 },
                    { x: 773, y: 345 },
                ]
            },
        ],
        image: 'assets/domy/dom4_miejski_szyk.jpg'
    },
];

const KlasycznaElegancja: KnaufProject[] = [
    {
        layers: [
            //lewy zielony
            {
                color: { code: 'C 3104 PG II', rgb: '#FDF2DD' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 223, y: 341 },
                        { x: 223, y: 355 },
                        { x: 247, y: 353 },
                        { x: 248, y: 340 },
                    ]
                ],

                points: [
                    { x: 189, y: 341 },
                    { x: 219, y: 340 },
                    { x: 256, y: 340 },
                    { x: 257, y: 358 },
                    { x: 257, y: 424 },
                    { x: 190, y: 421 },
                ]
            },

            //górny zielony lewy
            {
                color: { code: 'C 3104 PG II', rgb: '#FDF2DD' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 259, y: 208 },
                    { x: 325, y: 201 },
                    { x: 324, y: 261 },
                    { x: 258, y: 265 },
                ]
            },

            //górny zielony prawy
            {
                color: { code: 'C 3104 PG II', rgb: '#FDF2DD' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 398, y: 196 },
                        { x: 459, y: 191 },
                        { x: 458, y: 253 },
                        { x: 398, y: 258 },
                    ], [
                        { x: 481, y: 191 },
                        { x: 517, y: 204 },
                        { x: 516, y: 242 },
                        { x: 517, y: 249 },
                        { x: 486, y: 251 },
                        { x: 483, y: 251 },
                    ], [
                        { x: 628, y: 201 },
                        { x: 670, y: 198 },
                        { x: 671, y: 255 },
                        { x: 629, y: 258 },
                    ], [
                        { x: 693, y: 200 },
                        { x: 705, y: 206 },
                        { x: 705, y: 253 },
                        { x: 693, y: 253 },
                    ], [
                        { x: 729, y: 213 },
                        { x: 748, y: 211 },
                        { x: 771, y: 225 },
                        { x: 772, y: 271 },
                        { x: 728, y: 260 },
                    ]
                ],

                points: [
                    { x: 387, y: 197 },
                    { x: 472, y: 189 },
                    { x: 543, y: 209 },
                    { x: 688, y: 195 },
                    { x: 727, y: 212 },
                    { x: 748, y: 210 },
                    { x: 817, y: 242 },
                    { x: 818, y: 288 },
                    { x: 712, y: 255 },
                    { x: 618, y: 261 },
                    { x: 555, y: 247 },
                    { x: 386, y: 259 },
                ]
            },


            //glówna elewacja dół
            {
                color: { code: 'C 3121 PG III', rgb: '#C89B7F' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 325, y: 263 },
                        { x: 387, y: 258 },
                        { x: 386, y: 317 },
                        { x: 325, y: 321 },
                    ],
                    [
                        { x: 770, y: 333 },
                        { x: 779, y: 334 },
                        { x: 778, y: 391 },
                        { x: 770, y: 391 },
                    ],
                    [
                        { x: 804, y: 337 },
                        { x: 812, y: 339 },
                        { x: 811, y: 382 },
                        { x: 819, y: 390 },
                        { x: 804, y: 389 },
                    ],
                    [
                        { x: 793, y: 231 },
                        { x: 789, y: 422 },
                        { x: 793, y: 421 },
                        { x: 797, y: 234 },
                    ]

                ],

                points: [
                    { x: 258, y: 266 },
                    { x: 554, y: 249 },
                    { x: 621, y: 262 },
                    { x: 713, y: 256 },
                    { x: 819, y: 290 },
                    { x: 818, y: 418 },
                    { x: 714, y: 435 },
                    { x: 671, y: 434 },
                    { x: 673, y: 425 },
                    { x: 713, y: 425 },
                    { x: 748, y: 421 },
                    { x: 747, y: 330 },
                    { x: 712, y: 324 },
                    { x: 622, y: 329 },
                    { x: 551, y: 323 },
                    { x: 551, y: 312 },
                    { x: 387, y: 318 },
                    { x: 324, y: 323 },
                    { x: 323, y: 433 },
                    { x: 258, y: 431 },
                ]
            },


            //głowna elewacja
            {
                color: { code: 'C 3121 PG III', rgb: '#C89B7F' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 313, y: 182 },
                        { x: 313, y: 187 },
                        { x: 325, y: 202 },
                        { x: 385, y: 194 },
                        { x: 387, y: 187 },
                        { x: 371, y: 181 },
                        { x: 330, y: 185 },
                        { x: 329, y: 198 },
                    ],
                    [
                        { x: 792, y: 226 },
                        { x: 806, y: 220 },
                        { x: 806, y: 212 },
                        { x: 814, y: 213 },
                        { x: 812, y: 223 },
                        { x: 798, y: 229 },
                    ]

                ],

                points: [
                    { x: 206, y: 185 },
                    { x: 467, y: 151 },
                    { x: 555, y: 182 },
                    { x: 738, y: 162 },
                    { x: 849, y: 227 },
                    { x: 849, y: 235 },
                    { x: 820, y: 237 },
                    { x: 819, y: 244 },
                    { x: 750, y: 209 },
                    { x: 728, y: 212 },
                    { x: 688, y: 193 },
                    { x: 544, y: 207 },
                    { x: 471, y: 186 },
                    { x: 258, y: 206 },
                    { x: 209, y: 195 },
                ]
            },

            //komin lewy
            {
                color: { code: '4620', rgb: '#975941' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 386, y: 317 },
                        { x: 331, y: 329 },
                        { x: 332, y: 336 },
                        { x: 386, y: 335 },

                    ],
                    [
                        { x: 331, y: 162 },
                        { x: 372, y: 152 },
                        { x: 395, y: 142 },
                        { x: 387, y: 185 },
                        { x: 374, y: 182 },
                        { x: 331, y: 187 },
                    ]

                ],

                points: [
                    { x: 330, y: 97 },
                    { x: 371, y: 90 },
                    { x: 396, y: 101 },
                    { x: 395, y: 144 },
                    { x: 387, y: 187 },
                    { x: 387, y: 431 },
                    { x: 372, y: 436 },
                    { x: 330, y: 433 },
                ]
            },

            //komin prawy
            {
                color: { code: '4620', rgb: '#975941' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 654, y: 129 },
                    { x: 699, y: 123 },
                    { x: 707, y: 127 },
                    { x: 708, y: 147 },
                    { x: 654, y: 138 },
                ]
            },

            //wykonczenie lewe
            {
                color: { code: '4620', rgb: '#975941' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 589, y: 327 },
                    { x: 621, y: 328 },
                    { x: 621, y: 425 },
                    { x: 594, y: 428 },
                    { x: 588, y: 424 },
                ]
            },

            //wykonczenie prawe
            {
                color: { code: '4620', rgb: '#975941' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 672, y: 327 },
                    { x: 712, y: 326 },
                    { x: 748, y: 330 },
                    { x: 748, y: 422 },
                    { x: 712, y: 428 },
                    { x: 672, y: 428 },
                ]
            },

        ],
        image: 'assets/domy/dom1_klasyczna_elegancja.jpg'
    },
    {
        layers: [
            {
                color: { code: 'C 3084 PG II', rgb: '#FCFAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //lewo
                    { x: 130, y: 372 },
                    { x: 140, y: 371 },
                    { x: 140, y: 443 },
                    { x: 183, y: 444 },
                    { x: 181, y: 359 },
                    { x: 195, y: 354 },
                    { x: 254, y: 357 },
                    { x: 340, y: 342 },
                    { x: 341, y: 507 },
                    { x: 257, y: 497 },
                    { x: 196, y: 500 },
                    { x: 129, y: 489 },
                ]
            },
            {
                color: { code: 'C 3084 PG II', rgb: '#FCFAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //srodek
                    { x: 348, y: 341 },
                    { x: 360, y: 338 },
                    { x: 425, y: 344 },
                    { x: 426, y: 443 },
                    { x: 545, y: 442 },
                    { x: 545, y: 497 },
                    { x: 359, y: 507 },
                    { x: 348, y: 507 },

                ]
            },
            {
                color: { code: 'C 3084 PG II', rgb: '#FCFAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //prawo
                    { x: 673, y: 379 },
                    { x: 706, y: 376 },
                    { x: 786, y: 383 },
                    { x: 786, y: 392 },
                    { x: 738, y: 390 },
                    { x: 737, y: 445 },
                    { x: 786, y: 445 },
                    { x: 786, y: 382 },
                    { x: 906, y: 391 },
                    { x: 906, y: 495 },
                    { x: 885, y: 495 },
                    { x: 867, y: 496 },
                    { x: 868, y: 395 },
                    { x: 811, y: 395 },
                    { x: 808, y: 480 },
                    { x: 801, y: 477 },
                    { x: 793, y: 476 },
                    { x: 783, y: 475 },
                    { x: 774, y: 475 },
                    { x: 769, y: 482 },
                    { x: 761, y: 488 },
                    { x: 753, y: 492 },
                    { x: 751, y: 503 },
                    { x: 737, y: 503 },
                    { x: 737, y: 496 },
                    { x: 707, y: 496 },
                    { x: 672, y: 493 },
                ],
            },
            // dom2 srodkowa elewacja
            {
                color: { code: 'C 3433 PG II', rgb: '#CAC6BA' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //lewo
                    { x: 196, y: 330 },
                    { x: 254, y: 336 },
                    { x: 307, y: 321 },
                    { x: 341, y: 338 },
                    { x: 339, y: 344 },
                    { x: 255, y: 358 },
                    { x: 197, y: 355 },
                    { x: 129, y: 373 },
                ]
            },
            {
                color: { code: 'C 3433 PG II', rgb: '#CAC6BA' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //srodek
                    { x: 320, y: 321 },
                    { x: 358, y: 310 },
                    { x: 672, y: 342 },
                    { x: 672, y: 363 },
                    { x: 670, y: 372 },
                    { x: 673, y: 381 },
                    { x: 673, y: 491 },
                    { x: 647, y: 493 },
                    { x: 632, y: 493 },
                    { x: 632, y: 362 },
                    { x: 547, y: 360 },
                    { x: 547, y: 353 },
                    { x: 505, y: 353 },
                    { x: 426, y: 349 },
                    { x: 426, y: 343 },
                    { x: 359, y: 338 },
                    { x: 348, y: 341 },
                    { x: 349, y: 333 },
                ]
            },
            // dom2 górna elewacja
            {
                color: { code: 'C 3084 PG II', rgb: '#FCFAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 128, y: 353 },
                    { x: 125, y: 346 },
                    { x: 131, y: 341 },
                    { x: 130, y: 331 },
                    { x: 149, y: 285 },
                    { x: 165, y: 309 },
                    { x: 166, y: 323 },
                    { x: 172, y: 321 },
                    { x: 179, y: 331 },
                    { x: 195, y: 331 },

                ]
            },
            {
                color: { code: 'C 3084 PG II', rgb: '#FCFAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 568, y: 158 },
                    { x: 640, y: 176 },
                    { x: 665, y: 218 },
                    { x: 664, y: 228 },
                    { x: 672, y: 229 },
                    { x: 676, y: 239 },
                    { x: 676, y: 254 },
                    { x: 628, y: 246 },
                    { x: 629, y: 202 },
                    { x: 561, y: 189 },
                    { x: 559, y: 242 },
                    { x: 521, y: 253 },
                    { x: 521, y: 269 },
                    { x: 511, y: 257 },
                    { x: 511, y: 218 },
                    { x: 526, y: 198 },
                    { x: 544, y: 195 },
                    { x: 546, y: 182 },
                    { x: 537, y: 182 },

                ]
            },
            {
                color: { code: 'C 3084 PG II', rgb: '#FCFAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 525, y: 257 },
                    { x: 559, y: 248 },
                    { x: 559, y: 298 },
                    { x: 546, y: 301 },
                    { x: 525, y: 277 },

                ]
            },
            {
                color: { code: 'C 3084 PG II', rgb: '#FCFAE8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 636, y: 253 },
                    { x: 674, y: 259 },
                    { x: 675, y: 308 },
                    { x: 636, y: 302 },

                ]
            },
        ],
        image: 'assets/domy/dom2_klasyczna_elegancja.jpg'
    },
    {
        layers: [
            {
                color: { code: 'C 3104 PG II', rgb: '#FDF2DD' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 391, y: 88 },
                    { x: 243, y: 326 },
                    { x: 243, y: 373 },
                    { x: 344, y: 365 },
                    { x: 345, y: 251 },
                    { x: 426, y: 237 },
                    { x: 426, y: 357 },
                    { x: 592, y: 343 },
                    { x: 684, y: 361 },
                    { x: 684, y: 313 },
                    { x: 581, y: 285 },
                ]
            },
            {
                color: { code: 'C 3104 PG II', rgb: '#FDF2DD' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 843, y: 357 },
                    { x: 844, y: 415 },
                    { x: 798, y: 409 },
                    { x: 798, y: 500 },
                    { x: 886, y: 500 },
                    { x: 886, y: 368 },

                ]
            },
            {
                color: { code: 'C 3171 PG II', rgb: '#C7A599' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 189, y: 485 },
                    { x: 240, y: 485 },
                    { x: 240, y: 491 },
                    { x: 189, y: 491 },
                ],
            },
            {
                color: { code: 'C 3171 PG II', rgb: '#C7A599' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 737, y: 316 },
                    { x: 737, y: 369 },
                    { x: 776, y: 376 },
                    { x: 776, y: 328 },
                ],
            },
            {
                color: { code: 'C 3171 PG II', rgb: '#C7A599' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 808, y: 337 },
                    { x: 837, y: 345 },
                    { x: 837, y: 388 },
                    { x: 808, y: 382 },
                ],
            },
            {
                color: { code: 'C 3430 PG III', rgb: '#78726A' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 192, y: 380 },
                    { x: 192, y: 414 },
                    { x: 240, y: 413 },
                    { x: 240, y: 491 },
                    { x: 192, y: 491 },
                    { x: 192, y: 534 },
                    { x: 220, y: 528 },
                    { x: 302, y: 521 },
                    { x: 302, y: 396 },
                    { x: 592, y: 379 },
                    { x: 843, y: 415 },
                    { x: 843, y: 395 },
                    { x: 592, y: 348 },

                ],
            },
            {
                color: { code: 'C 3171 PG II', rgb: '#C7A599' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 303, y: 397 },
                    { x: 303, y: 520 },
                    { x: 349, y: 519 },
                    { x: 349, y: 400 },
                    { x: 631, y: 385 },
                    { x: 592, y: 379 },
                ],
            },
        ],
        image: 'assets/domy/dom3_klasyczna_elegancja.jpg'
    },
    {
        layers: [
            //  dom4 jasnozielony lewy
            {
                color: { code: 'C 3151 PG III', rgb: '#B2786D' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 211, y: 208 },
                        { x: 274, y: 201 },
                        { x: 272, y: 410 },
                        { x: 213, y: 409 },
                        { x: 213, y: 353 },
                        { x: 210, y: 347 },
                        { x: 207, y: 344 },
                        { x: 208, y: 271 },
                    ]
                ],
                points: [
                    { x: 161, y: 155 },
                    { x: 340, y: 127 },
                    { x: 340, y: 180 },
                    { x: 345, y: 183 },
                    { x: 345, y: 376 },
                    { x: 340, y: 378 },
                    { x: 340, y: 458 },
                    { x: 162, y: 453 },
                ]
            },

            //dom4 gora jasnozielony
            {
                color: { code: 'C 3151 PG III', rgb: '#B2786D' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 498, y: 239 },
                    { x: 493, y: 239 },
                    { x: 492, y: 174 },
                    { x: 612, y: 162 },
                    { x: 635, y: 174 },
                    { x: 636, y: 112 },
                    { x: 725, y: 182 },
                    { x: 726, y: 232 },
                    { x: 712, y: 223 },
                    { x: 719, y: 222 },
                    { x: 716, y: 220 },
                    { x: 704, y: 222 },
                    { x: 688, y: 215 },
                    { x: 688, y: 250 },
                    { x: 636, y: 254 },
                    { x: 635, y: 242 },
                    { x: 627, y: 237 },
                    { x: 628, y: 176 },
                    { x: 607, y: 168 },
                    { x: 498, y: 178 },

                ]
            },

            //dom4 srodek bezowy
            {
                color: { code: 'C 3394 PG II', rgb: '#E7E4D5' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 340, y: 99 },
                    { x: 467, y: 80 },
                    { x: 511, y: 105 },
                    { x: 492, y: 109 },
                    { x: 494, y: 335 },
                    { x: 520, y: 338 },
                    { x: 521, y: 458 },
                    { x: 484, y: 464 },
                    { x: 483, y: 475 },
                    { x: 467, y: 477 },
                    { x: 429, y: 477 },
                    { x: 427, y: 459 },
                    { x: 418, y: 461 },
                    { x: 418, y: 478 },
                    { x: 341, y: 474 },
                    { x: 340, y: 378 },
                    { x: 427, y: 377 },
                    { x: 425, y: 171 },
                    { x: 340, y: 182 },

                ]
            },


            //dom4 dodatkowy bezowy
            {
                color: { code: 'C 3394 PG II', rgb: '#E7E4D5' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 618, y: 365 },
                        { x: 629, y: 365 },
                        { x: 628, y: 374 },
                        { x: 618, y: 374 },
                    ],
                    [
                        { x: 619, y: 401 },
                        { x: 628, y: 401 },
                        { x: 620, y: 410 },
                        { x: 619, y: 410 },
                    ],
                    [
                        { x: 619, y: 435 },
                        { x: 628, y: 435 },
                        { x: 628, y: 446 },
                        { x: 619, y: 446 },
                    ]

                ],
                points: [
                    { x: 608, y: 351 },
                    { x: 642, y: 348 },
                    { x: 644, y: 461 },
                    { x: 607, y: 461 },
                ]
            },

            //dom4 bok brazowy
            {
                color: { code: '4780', rgb: '#8C5047' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 543, y: 353 },
                    { x: 544, y: 458 },
                    { x: 520, y: 458 },
                    { x: 520, y: 338 },
                    { x: 602, y: 335 },
                    { x: 610, y: 337 },
                    { x: 636, y: 338 },
                    { x: 635, y: 304 },
                    { x: 816, y: 294 },
                    { x: 853, y: 318 },
                    { x: 854, y: 451 },
                    { x: 855, y: 464 },
                    { x: 819, y: 477 },
                    { x: 807, y: 477 },
                    { x: 805, y: 464 },
                    { x: 814, y: 458 },
                    { x: 805, y: 458 },
                    { x: 801, y: 452 },
                    { x: 798, y: 458 },
                    { x: 795, y: 465 },
                    { x: 773, y: 465 },
                    { x: 773, y: 345 },
                ]
            },
        ],
        image: 'assets/domy/dom4_klasyczna_elegancja.jpg'
    },
];

const SwiatoweInspiracje: KnaufProject[] = [
    {
        layers: [
            //lewy zielony
            {
                color: { code: 'C 3320 PG III', rgb: '#92AA96' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 223, y: 341 },
                        { x: 223, y: 355 },
                        { x: 247, y: 353 },
                        { x: 248, y: 340 },
                    ]
                ],

                points: [
                    { x: 189, y: 341 },
                    { x: 219, y: 340 },
                    { x: 256, y: 340 },
                    { x: 257, y: 358 },
                    { x: 257, y: 424 },
                    { x: 190, y: 421 },
                ]
            },

            //górny zielony lewy
            {
                color: { code: 'C 3320 PG III', rgb: '#92AA96' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 259, y: 208 },
                    { x: 325, y: 201 },
                    { x: 324, y: 261 },
                    { x: 258, y: 265 },
                ]
            },

            //górny zielony prawy
            {
                color: { code: 'C 3320 PG III', rgb: '#92AA96' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 398, y: 196 },
                        { x: 459, y: 191 },
                        { x: 458, y: 253 },
                        { x: 398, y: 258 },
                    ], [
                        { x: 481, y: 191 },
                        { x: 517, y: 204 },
                        { x: 516, y: 242 },
                        { x: 517, y: 249 },
                        { x: 486, y: 251 },
                        { x: 483, y: 251 },
                    ], [
                        { x: 628, y: 201 },
                        { x: 670, y: 198 },
                        { x: 671, y: 255 },
                        { x: 629, y: 258 },
                    ], [
                        { x: 693, y: 200 },
                        { x: 705, y: 206 },
                        { x: 705, y: 253 },
                        { x: 693, y: 253 },
                    ], [
                        { x: 729, y: 213 },
                        { x: 748, y: 211 },
                        { x: 771, y: 225 },
                        { x: 772, y: 271 },
                        { x: 728, y: 260 },
                    ]
                ],

                points: [
                    { x: 387, y: 197 },
                    { x: 472, y: 189 },
                    { x: 543, y: 209 },
                    { x: 688, y: 195 },
                    { x: 727, y: 212 },
                    { x: 748, y: 210 },
                    { x: 817, y: 242 },
                    { x: 818, y: 288 },
                    { x: 712, y: 255 },
                    { x: 618, y: 261 },
                    { x: 555, y: 247 },
                    { x: 386, y: 259 },
                ]
            },


            //glówna elewacja dół
            {
                color: { code: 'C 3064 PG II', rgb: '#FEF1CE' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 325, y: 263 },
                        { x: 387, y: 258 },
                        { x: 386, y: 317 },
                        { x: 325, y: 321 },
                    ],
                    [
                        { x: 770, y: 333 },
                        { x: 779, y: 334 },
                        { x: 778, y: 391 },
                        { x: 770, y: 391 },
                    ],
                    [
                        { x: 804, y: 337 },
                        { x: 812, y: 339 },
                        { x: 811, y: 382 },
                        { x: 819, y: 390 },
                        { x: 804, y: 389 },
                    ],
                    [
                        { x: 793, y: 231 },
                        { x: 789, y: 422 },
                        { x: 793, y: 421 },
                        { x: 797, y: 234 },
                    ]

                ],

                points: [
                    { x: 258, y: 266 },
                    { x: 554, y: 249 },
                    { x: 621, y: 262 },
                    { x: 713, y: 256 },
                    { x: 819, y: 290 },
                    { x: 818, y: 418 },
                    { x: 714, y: 435 },
                    { x: 671, y: 434 },
                    { x: 673, y: 425 },
                    { x: 713, y: 425 },
                    { x: 748, y: 421 },
                    { x: 747, y: 330 },
                    { x: 712, y: 324 },
                    { x: 622, y: 329 },
                    { x: 551, y: 323 },
                    { x: 551, y: 312 },
                    { x: 387, y: 318 },
                    { x: 324, y: 323 },
                    { x: 323, y: 433 },
                    { x: 258, y: 431 },
                ]
            },


            //głowna elewacja
            {
                color: { code: 'C 3064 PG II', rgb: '#FEF1CE' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 313, y: 182 },
                        { x: 313, y: 187 },
                        { x: 325, y: 202 },
                        { x: 385, y: 194 },
                        { x: 387, y: 187 },
                        { x: 371, y: 181 },
                        { x: 330, y: 185 },
                        { x: 329, y: 198 },
                    ],
                    [
                        { x: 792, y: 226 },
                        { x: 806, y: 220 },
                        { x: 806, y: 212 },
                        { x: 814, y: 213 },
                        { x: 812, y: 223 },
                        { x: 798, y: 229 },
                    ]

                ],

                points: [
                    { x: 206, y: 185 },
                    { x: 467, y: 151 },
                    { x: 555, y: 182 },
                    { x: 738, y: 162 },
                    { x: 849, y: 227 },
                    { x: 849, y: 235 },
                    { x: 820, y: 237 },
                    { x: 819, y: 244 },
                    { x: 750, y: 209 },
                    { x: 728, y: 212 },
                    { x: 688, y: 193 },
                    { x: 544, y: 207 },
                    { x: 471, y: 186 },
                    { x: 258, y: 206 },
                    { x: 209, y: 195 },
                ]
            },

            //komin lewy
            {
                color: { code: '4840', rgb: '#465959' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 386, y: 317 },
                        { x: 331, y: 329 },
                        { x: 332, y: 336 },
                        { x: 386, y: 335 },

                    ],
                    [
                        { x: 331, y: 162 },
                        { x: 372, y: 152 },
                        { x: 395, y: 142 },
                        { x: 387, y: 185 },
                        { x: 374, y: 182 },
                        { x: 331, y: 187 },
                    ]

                ],

                points: [
                    { x: 330, y: 97 },
                    { x: 371, y: 90 },
                    { x: 396, y: 101 },
                    { x: 395, y: 144 },
                    { x: 387, y: 187 },
                    { x: 387, y: 431 },
                    { x: 372, y: 436 },
                    { x: 330, y: 433 },
                ]
            },

            //komin prawy
            {
                color: { code: '4840', rgb: '#465959' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 654, y: 129 },
                    { x: 699, y: 123 },
                    { x: 707, y: 127 },
                    { x: 708, y: 147 },
                    { x: 654, y: 138 },
                ]
            },

            //wykonczenie lewe
            {
                color: { code: '4050', rgb: '#D29645' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 589, y: 327 },
                    { x: 621, y: 328 },
                    { x: 621, y: 425 },
                    { x: 594, y: 428 },
                    { x: 588, y: 424 },
                ]
            },

            //wykonczenie prawe
            {
                color: { code: '4050', rgb: '#D29645' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 672, y: 327 },
                    { x: 712, y: 326 },
                    { x: 748, y: 330 },
                    { x: 748, y: 422 },
                    { x: 712, y: 428 },
                    { x: 672, y: 428 },
                ]
            },
        ],
        image: 'assets/domy/dom1_swiatowe_inspiracje.jpg'
    },
    {
        layers: [
            {
                color: { code: 'C 3123 PG II', rgb: '#E7CDB8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //lewo
                    { x: 130, y: 372 },
                    { x: 140, y: 371 },
                    { x: 140, y: 443 },
                    { x: 183, y: 444 },
                    { x: 181, y: 359 },
                    { x: 195, y: 354 },
                    { x: 254, y: 357 },
                    { x: 340, y: 342 },
                    { x: 341, y: 507 },
                    { x: 257, y: 497 },
                    { x: 196, y: 500 },
                    { x: 129, y: 489 },
                ]
            },
            {
                color: { code: 'C 3123 PG II', rgb: '#E7CDB8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //srodek
                    { x: 348, y: 341 },
                    { x: 360, y: 338 },
                    { x: 425, y: 344 },
                    { x: 426, y: 443 },
                    { x: 545, y: 442 },
                    { x: 545, y: 497 },
                    { x: 359, y: 507 },
                    { x: 348, y: 507 },

                ]
            },
            {
                color: { code: 'C 3123 PG II', rgb: '#E7CDB8' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //prawo
                    { x: 673, y: 379 },
                    { x: 706, y: 376 },
                    { x: 786, y: 383 },
                    { x: 786, y: 392 },
                    { x: 738, y: 390 },
                    { x: 737, y: 445 },
                    { x: 786, y: 445 },
                    { x: 786, y: 382 },
                    { x: 906, y: 391 },
                    { x: 906, y: 495 },
                    { x: 885, y: 495 },
                    { x: 867, y: 496 },
                    { x: 868, y: 395 },
                    { x: 811, y: 395 },
                    { x: 808, y: 480 },
                    { x: 801, y: 477 },
                    { x: 793, y: 476 },
                    { x: 783, y: 475 },
                    { x: 774, y: 475 },
                    { x: 769, y: 482 },
                    { x: 761, y: 488 },
                    { x: 753, y: 492 },
                    { x: 751, y: 503 },
                    { x: 737, y: 503 },
                    { x: 737, y: 496 },
                    { x: 707, y: 496 },
                    { x: 672, y: 493 },
                ],
            },
            // dom2 srodkowa elewacja
            {
                color: { code: 'C 3160 PG II', rgb: '#C08A7C' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //lewo
                    { x: 196, y: 330 },
                    { x: 254, y: 336 },
                    { x: 307, y: 321 },
                    { x: 341, y: 338 },
                    { x: 339, y: 344 },
                    { x: 255, y: 358 },
                    { x: 197, y: 355 },
                    { x: 129, y: 373 },
                ]
            },
            {
                color: { code: 'C 3160 PG II', rgb: '#C08A7C' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //srodek
                    { x: 320, y: 321 },
                    { x: 358, y: 310 },
                    { x: 672, y: 342 },
                    { x: 672, y: 363 },
                    { x: 670, y: 372 },
                    { x: 673, y: 381 },
                    { x: 673, y: 491 },
                    { x: 647, y: 493 },
                    { x: 632, y: 493 },
                    { x: 632, y: 362 },
                    { x: 547, y: 360 },
                    { x: 547, y: 353 },
                    { x: 505, y: 353 },
                    { x: 426, y: 349 },
                    { x: 426, y: 343 },
                    { x: 359, y: 338 },
                    { x: 348, y: 341 },
                    { x: 349, y: 333 },
                ]
            },
            // dom2 górna elewacja
            {
                color: { code: 'C 3180 PG III', rgb: '#926B6C' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 128, y: 353 },
                    { x: 125, y: 346 },
                    { x: 131, y: 341 },
                    { x: 130, y: 331 },
                    { x: 149, y: 285 },
                    { x: 165, y: 309 },
                    { x: 166, y: 323 },
                    { x: 172, y: 321 },
                    { x: 179, y: 331 },
                    { x: 195, y: 331 },

                ]
            },
            {
                color: { code: 'C 3180 PG III', rgb: '#926B6C' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 568, y: 158 },
                    { x: 640, y: 176 },
                    { x: 665, y: 218 },
                    { x: 664, y: 228 },
                    { x: 672, y: 229 },
                    { x: 676, y: 239 },
                    { x: 676, y: 254 },
                    { x: 628, y: 246 },
                    { x: 629, y: 202 },
                    { x: 561, y: 189 },
                    { x: 559, y: 242 },
                    { x: 521, y: 253 },
                    { x: 521, y: 269 },
                    { x: 511, y: 257 },
                    { x: 511, y: 218 },
                    { x: 526, y: 198 },
                    { x: 544, y: 195 },
                    { x: 546, y: 182 },
                    { x: 537, y: 182 },

                ]
            },
            {
                color: { code: 'C 3180 PG III', rgb: '#926B6C' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 525, y: 257 },
                    { x: 559, y: 248 },
                    { x: 559, y: 298 },
                    { x: 546, y: 301 },
                    { x: 525, y: 277 },

                ]
            },
            {
                color: { code: 'C 3180 PG III', rgb: '#926B6C' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 636, y: 253 },
                    { x: 674, y: 259 },
                    { x: 675, y: 308 },
                    { x: 636, y: 302 },

                ]
            },
        ],
        image: 'assets/domy/dom2_swiatowe_inspiracje.jpg'
    },
    {
        layers: [
            {
                color: { code: 'C 3230 PG III', rgb: '#8DAFC5' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 391, y: 88 },
                    { x: 243, y: 326 },
                    { x: 243, y: 373 },
                    { x: 344, y: 365 },
                    { x: 345, y: 251 },
                    { x: 426, y: 237 },
                    { x: 426, y: 357 },
                    { x: 592, y: 343 },
                    { x: 684, y: 361 },
                    { x: 684, y: 313 },
                    { x: 581, y: 285 },
                ]
            },
            {
                color: { code: 'C 3230 PG III', rgb: '#8DAFC5' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 843, y: 357 },
                    { x: 844, y: 415 },
                    { x: 798, y: 409 },
                    { x: 798, y: 500 },
                    { x: 886, y: 500 },
                    { x: 886, y: 368 },

                ]
            },
            {
                color: { code: '4260', rgb: '#40627D' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 189, y: 485 },
                    { x: 240, y: 485 },
                    { x: 240, y: 491 },
                    { x: 189, y: 491 },
                ],
            },
            {
                color: { code: '4260', rgb: '#40627D' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 737, y: 316 },
                    { x: 737, y: 369 },
                    { x: 776, y: 376 },
                    { x: 776, y: 328 },
                ],
            },
            {
                color: { code: '4260', rgb: '#40627D' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 808, y: 337 },
                    { x: 837, y: 345 },
                    { x: 837, y: 388 },
                    { x: 808, y: 382 },
                ],
            },
            {
                color: { code: 'C 3533 PG III', rgb: '#E2EDEA' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 192, y: 380 },
                    { x: 192, y: 414 },
                    { x: 240, y: 413 },
                    { x: 240, y: 491 },
                    { x: 192, y: 491 },
                    { x: 192, y: 534 },
                    { x: 220, y: 528 },
                    { x: 302, y: 521 },
                    { x: 302, y: 396 },
                    { x: 592, y: 379 },
                    { x: 843, y: 415 },
                    { x: 843, y: 395 },
                    { x: 592, y: 348 },

                ],
            },
            {
                color: { code: 'C 3230 PG III', rgb: '#8DAFC5' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 303, y: 397 },
                    { x: 303, y: 520 },
                    { x: 349, y: 519 },
                    { x: 349, y: 400 },
                    { x: 631, y: 385 },
                    { x: 592, y: 379 },
                ],
            },
        ],
        image: 'assets/domy/dom3_swiatowe_inspiracje.jpg'
    },
    {
        layers: [
            //  dom4 jasnozielony lewy
            {
                color: { code: 'C 3541 PG III', rgb: '#A6B7AF' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 211, y: 208 },
                        { x: 274, y: 201 },
                        { x: 272, y: 410 },
                        { x: 213, y: 409 },
                        { x: 213, y: 353 },
                        { x: 210, y: 347 },
                        { x: 207, y: 344 },
                        { x: 208, y: 271 },
                    ]
                ],
                points: [
                    { x: 161, y: 155 },
                    { x: 340, y: 127 },
                    { x: 340, y: 180 },
                    { x: 345, y: 183 },
                    { x: 345, y: 376 },
                    { x: 340, y: 378 },
                    { x: 340, y: 458 },
                    { x: 162, y: 453 },
                ]
            },

            //dom4 gora jasnozielony
            {
                color: { code: 'C 3541 PG III', rgb: '#A6B7AF' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 498, y: 239 },
                    { x: 493, y: 239 },
                    { x: 492, y: 174 },
                    { x: 612, y: 162 },
                    { x: 635, y: 174 },
                    { x: 636, y: 112 },
                    { x: 725, y: 182 },
                    { x: 726, y: 232 },
                    { x: 712, y: 223 },
                    { x: 719, y: 222 },
                    { x: 716, y: 220 },
                    { x: 704, y: 222 },
                    { x: 688, y: 215 },
                    { x: 688, y: 250 },
                    { x: 636, y: 254 },
                    { x: 635, y: 242 },
                    { x: 627, y: 237 },
                    { x: 628, y: 176 },
                    { x: 607, y: 168 },
                    { x: 498, y: 178 },

                ]
            },

            //dom4 srodek bezowy
            {
                color: { code: 'C 3112 PG II', rgb: '#E6B587' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 340, y: 99 },
                    { x: 467, y: 80 },
                    { x: 511, y: 105 },
                    { x: 492, y: 109 },
                    { x: 494, y: 335 },
                    { x: 520, y: 338 },
                    { x: 521, y: 458 },
                    { x: 484, y: 464 },
                    { x: 483, y: 475 },
                    { x: 467, y: 477 },
                    { x: 429, y: 477 },
                    { x: 427, y: 459 },
                    { x: 418, y: 461 },
                    { x: 418, y: 478 },
                    { x: 341, y: 474 },
                    { x: 340, y: 378 },
                    { x: 427, y: 377 },
                    { x: 425, y: 171 },
                    { x: 340, y: 182 },

                ]
            },


            //dom4 dodatkowy bezowy
            {
                color: { code: 'C 3112 PG II', rgb: '#E6B587' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 618, y: 365 },
                        { x: 629, y: 365 },
                        { x: 628, y: 374 },
                        { x: 618, y: 374 },
                    ],
                    [
                        { x: 619, y: 401 },
                        { x: 628, y: 401 },
                        { x: 620, y: 410 },
                        { x: 619, y: 410 },
                    ],
                    [
                        { x: 619, y: 435 },
                        { x: 628, y: 435 },
                        { x: 628, y: 446 },
                        { x: 619, y: 446 },
                    ]

                ],
                points: [
                    { x: 608, y: 351 },
                    { x: 642, y: 348 },
                    { x: 644, y: 461 },
                    { x: 607, y: 461 },
                ]
            },

            //dom4 bok brazowy
            {
                color: { code: '4100', rgb: '#AF5637' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 543, y: 353 },
                    { x: 544, y: 458 },
                    { x: 520, y: 458 },
                    { x: 520, y: 338 },
                    { x: 602, y: 335 },
                    { x: 610, y: 337 },
                    { x: 636, y: 338 },
                    { x: 635, y: 304 },
                    { x: 816, y: 294 },
                    { x: 853, y: 318 },
                    { x: 854, y: 451 },
                    { x: 855, y: 464 },
                    { x: 819, y: 477 },
                    { x: 807, y: 477 },
                    { x: 805, y: 464 },
                    { x: 814, y: 458 },
                    { x: 805, y: 458 },
                    { x: 801, y: 452 },
                    { x: 798, y: 458 },
                    { x: 795, y: 465 },
                    { x: 773, y: 465 },
                    { x: 773, y: 345 },
                ]
            },
        ],
        image: 'assets/domy/dom4_swiatowe_inspiracje.jpg'
    },
];

const WZgodzieZNatura: KnaufProject[] = [
    {
        layers: [
            //lewy zielony
            {
                color: { code: 'C 3382 PG II', rgb: '#CECAB4' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 223, y: 341 },
                        { x: 223, y: 355 },
                        { x: 247, y: 353 },
                        { x: 248, y: 340 },
                    ]
                ],

                points: [
                    { x: 189, y: 341 },
                    { x: 219, y: 340 },
                    { x: 256, y: 340 },
                    { x: 257, y: 358 },
                    { x: 257, y: 424 },
                    { x: 190, y: 421 },
                ]
            },

            //górny zielony lewy
            {
                color: { code: 'C 3382 PG II', rgb: '#CECAB4' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 259, y: 208 },
                    { x: 325, y: 201 },
                    { x: 324, y: 261 },
                    { x: 258, y: 265 },
                ]
            },

            //górny zielony prawy
            {
                color: { code: 'C 3382 PG II', rgb: '#CECAB4' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 398, y: 196 },
                        { x: 459, y: 191 },
                        { x: 458, y: 253 },
                        { x: 398, y: 258 },
                    ], [
                        { x: 481, y: 191 },
                        { x: 517, y: 204 },
                        { x: 516, y: 242 },
                        { x: 517, y: 249 },
                        { x: 486, y: 251 },
                        { x: 483, y: 251 },
                    ], [
                        { x: 628, y: 201 },
                        { x: 670, y: 198 },
                        { x: 671, y: 255 },
                        { x: 629, y: 258 },
                    ], [
                        { x: 693, y: 200 },
                        { x: 705, y: 206 },
                        { x: 705, y: 253 },
                        { x: 693, y: 253 },
                    ], [
                        { x: 729, y: 213 },
                        { x: 748, y: 211 },
                        { x: 771, y: 225 },
                        { x: 772, y: 271 },
                        { x: 728, y: 260 },
                    ]
                ],

                points: [
                    { x: 387, y: 197 },
                    { x: 472, y: 189 },
                    { x: 543, y: 209 },
                    { x: 688, y: 195 },
                    { x: 727, y: 212 },
                    { x: 748, y: 210 },
                    { x: 817, y: 242 },
                    { x: 818, y: 288 },
                    { x: 712, y: 255 },
                    { x: 618, y: 261 },
                    { x: 555, y: 247 },
                    { x: 386, y: 259 },
                ]
            },


            //glówna elewacja dół
            {
                color: { code: 'C 3340 PG III', rgb: '#95A983' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 325, y: 263 },
                        { x: 387, y: 258 },
                        { x: 386, y: 317 },
                        { x: 325, y: 321 },
                    ],
                    [
                        { x: 770, y: 333 },
                        { x: 779, y: 334 },
                        { x: 778, y: 391 },
                        { x: 770, y: 391 },
                    ],
                    [
                        { x: 804, y: 337 },
                        { x: 812, y: 339 },
                        { x: 811, y: 382 },
                        { x: 819, y: 390 },
                        { x: 804, y: 389 },
                    ],
                    [
                        { x: 793, y: 231 },
                        { x: 789, y: 422 },
                        { x: 793, y: 421 },
                        { x: 797, y: 234 },
                    ]

                ],

                points: [
                    { x: 258, y: 266 },
                    { x: 554, y: 249 },
                    { x: 621, y: 262 },
                    { x: 713, y: 256 },
                    { x: 819, y: 290 },
                    { x: 818, y: 418 },
                    { x: 714, y: 435 },
                    { x: 671, y: 434 },
                    { x: 673, y: 425 },
                    { x: 713, y: 425 },
                    { x: 748, y: 421 },
                    { x: 747, y: 330 },
                    { x: 712, y: 324 },
                    { x: 622, y: 329 },
                    { x: 551, y: 323 },
                    { x: 551, y: 312 },
                    { x: 387, y: 318 },
                    { x: 324, y: 323 },
                    { x: 323, y: 433 },
                    { x: 258, y: 431 },
                ]
            },


            //głowna elewacja
            {
                color: { code: 'C 3340 PG III', rgb: '#95A983' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 313, y: 182 },
                        { x: 313, y: 187 },
                        { x: 325, y: 202 },
                        { x: 385, y: 194 },
                        { x: 387, y: 187 },
                        { x: 371, y: 181 },
                        { x: 330, y: 185 },
                        { x: 329, y: 198 },
                    ],
                    [
                        { x: 792, y: 226 },
                        { x: 806, y: 220 },
                        { x: 806, y: 212 },
                        { x: 814, y: 213 },
                        { x: 812, y: 223 },
                        { x: 798, y: 229 },
                    ]

                ],

                points: [
                    { x: 206, y: 185 },
                    { x: 467, y: 151 },
                    { x: 555, y: 182 },
                    { x: 738, y: 162 },
                    { x: 849, y: 227 },
                    { x: 849, y: 235 },
                    { x: 820, y: 237 },
                    { x: 819, y: 244 },
                    { x: 750, y: 209 },
                    { x: 728, y: 212 },
                    { x: 688, y: 193 },
                    { x: 544, y: 207 },
                    { x: 471, y: 186 },
                    { x: 258, y: 206 },
                    { x: 209, y: 195 },
                ]
            },

            //komin lewy
            {
                color: { code: '4043', rgb: '#FDDF84' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 386, y: 317 },
                        { x: 331, y: 329 },
                        { x: 332, y: 336 },
                        { x: 386, y: 335 },

                    ],
                    [
                        { x: 331, y: 162 },
                        { x: 372, y: 152 },
                        { x: 395, y: 142 },
                        { x: 387, y: 185 },
                        { x: 374, y: 182 },
                        { x: 331, y: 187 },
                    ]

                ],

                points: [
                    { x: 330, y: 97 },
                    { x: 371, y: 90 },
                    { x: 396, y: 101 },
                    { x: 395, y: 144 },
                    { x: 387, y: 187 },
                    { x: 387, y: 431 },
                    { x: 372, y: 436 },
                    { x: 330, y: 433 },
                ]
            },

            //komin prawy
            {
                color: { code: '4043', rgb: '#FDDF84' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 654, y: 129 },
                    { x: 699, y: 123 },
                    { x: 707, y: 127 },
                    { x: 708, y: 147 },
                    { x: 654, y: 138 },
                ]
            },

            //wykonczenie lewe
            {
                color: { code: '4043', rgb: '#FDDF84' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 589, y: 327 },
                    { x: 621, y: 328 },
                    { x: 621, y: 425 },
                    { x: 594, y: 428 },
                    { x: 588, y: 424 },
                ]
            },

            //wykonczenie prawe
            {
                color: { code: '4043', rgb: '#FDDF84' },
                selected: false, name: null, opacity: 80,
                cuts: [
                ],

                points: [
                    { x: 672, y: 327 },
                    { x: 712, y: 326 },
                    { x: 748, y: 330 },
                    { x: 748, y: 422 },
                    { x: 712, y: 428 },
                    { x: 672, y: 428 },
                ]
            },
        ],
        image: 'assets/domy/dom1_w_zgodzie_z_natura.jpg'
    },
    {
        layers: [
            {
                color: { code: 'C 3341 PG II', rgb: '#B3C4A3' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //lewo
                    { x: 130, y: 372 },
                    { x: 140, y: 371 },
                    { x: 140, y: 443 },
                    { x: 183, y: 444 },
                    { x: 181, y: 359 },
                    { x: 195, y: 354 },
                    { x: 254, y: 357 },
                    { x: 340, y: 342 },
                    { x: 341, y: 507 },
                    { x: 257, y: 497 },
                    { x: 196, y: 500 },
                    { x: 129, y: 489 },
                ]
            },
            {
                color: { code: 'C 3341 PG II', rgb: '#B3C4A3' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //srodek
                    { x: 348, y: 341 },
                    { x: 360, y: 338 },
                    { x: 425, y: 344 },
                    { x: 426, y: 443 },
                    { x: 545, y: 442 },
                    { x: 545, y: 497 },
                    { x: 359, y: 507 },
                    { x: 348, y: 507 },

                ]
            },
            {
                color: { code: 'C 3341 PG II', rgb: '#B3C4A3' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //prawo
                    { x: 673, y: 379 },
                    { x: 706, y: 376 },
                    { x: 786, y: 383 },
                    { x: 786, y: 392 },
                    { x: 738, y: 390 },
                    { x: 737, y: 445 },
                    { x: 786, y: 445 },
                    { x: 786, y: 382 },
                    { x: 906, y: 391 },
                    { x: 906, y: 495 },
                    { x: 885, y: 495 },
                    { x: 867, y: 496 },
                    { x: 868, y: 395 },
                    { x: 811, y: 395 },
                    { x: 808, y: 480 },
                    { x: 801, y: 477 },
                    { x: 793, y: 476 },
                    { x: 783, y: 475 },
                    { x: 774, y: 475 },
                    { x: 769, y: 482 },
                    { x: 761, y: 488 },
                    { x: 753, y: 492 },
                    { x: 751, y: 503 },
                    { x: 737, y: 503 },
                    { x: 737, y: 496 },
                    { x: 707, y: 496 },
                    { x: 672, y: 493 },
                ],
            },
            // dom2 srodkowa elewacja
            {
                color: { code: 'C 3434 PG II', rgb: '#E3E3DA' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //lewo
                    { x: 196, y: 330 },
                    { x: 254, y: 336 },
                    { x: 307, y: 321 },
                    { x: 341, y: 338 },
                    { x: 339, y: 344 },
                    { x: 255, y: 358 },
                    { x: 197, y: 355 },
                    { x: 129, y: 373 },
                ]
            },
            {
                color: { code: 'C 3434 PG II', rgb: '#E3E3DA' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    //srodek
                    { x: 320, y: 321 },
                    { x: 358, y: 310 },
                    { x: 672, y: 342 },
                    { x: 672, y: 363 },
                    { x: 670, y: 372 },
                    { x: 673, y: 381 },
                    { x: 673, y: 491 },
                    { x: 647, y: 493 },
                    { x: 632, y: 493 },
                    { x: 632, y: 362 },
                    { x: 547, y: 360 },
                    { x: 547, y: 353 },
                    { x: 505, y: 353 },
                    { x: 426, y: 349 },
                    { x: 426, y: 343 },
                    { x: 359, y: 338 },
                    { x: 348, y: 341 },
                    { x: 349, y: 333 },
                ]
            },
            // dom2 górna elewacja
            {
                color: { code: '4490', rgb: '#B5C14F' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 128, y: 353 },
                    { x: 125, y: 346 },
                    { x: 131, y: 341 },
                    { x: 130, y: 331 },
                    { x: 149, y: 285 },
                    { x: 165, y: 309 },
                    { x: 166, y: 323 },
                    { x: 172, y: 321 },
                    { x: 179, y: 331 },
                    { x: 195, y: 331 },

                ]
            },
            {
                color: { code: '4490', rgb: '#B5C14F' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 568, y: 158 },
                    { x: 640, y: 176 },
                    { x: 665, y: 218 },
                    { x: 664, y: 228 },
                    { x: 672, y: 229 },
                    { x: 676, y: 239 },
                    { x: 676, y: 254 },
                    { x: 628, y: 246 },
                    { x: 629, y: 202 },
                    { x: 561, y: 189 },
                    { x: 559, y: 242 },
                    { x: 521, y: 253 },
                    { x: 521, y: 269 },
                    { x: 511, y: 257 },
                    { x: 511, y: 218 },
                    { x: 526, y: 198 },
                    { x: 544, y: 195 },
                    { x: 546, y: 182 },
                    { x: 537, y: 182 },

                ]
            },
            {
                color: { code: '4490', rgb: '#B5C14F' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 525, y: 257 },
                    { x: 559, y: 248 },
                    { x: 559, y: 298 },
                    { x: 546, y: 301 },
                    { x: 525, y: 277 },

                ]
            },
            {
                color: { code: '4490', rgb: '#B5C14F' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 636, y: 253 },
                    { x: 674, y: 259 },
                    { x: 675, y: 308 },
                    { x: 636, y: 302 },

                ]
            },
        ],
        image: 'assets/domy/dom2_w_zgodzie_z_natura.jpg'
    },
    {
        layers: [
            {
                color: { code: 'C 3470 PG III', rgb: '#838984' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 391, y: 88 },
                    { x: 243, y: 326 },
                    { x: 243, y: 373 },
                    { x: 344, y: 365 },
                    { x: 345, y: 251 },
                    { x: 426, y: 237 },
                    { x: 426, y: 357 },
                    { x: 592, y: 343 },
                    { x: 684, y: 361 },
                    { x: 684, y: 313 },
                    { x: 581, y: 285 },
                ]
            },
            {
                color: { code: 'C 3470 PG III', rgb: '#838984' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 843, y: 357 },
                    { x: 844, y: 415 },
                    { x: 798, y: 409 },
                    { x: 798, y: 500 },
                    { x: 886, y: 500 },
                    { x: 886, y: 368 },

                ]
            },
            {
                color: { code: '4043', rgb: '#FDDF84' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 189, y: 485 },
                    { x: 240, y: 485 },
                    { x: 240, y: 491 },
                    { x: 189, y: 491 },
                ],
            },
            {
                color: { code: '4043', rgb: '#FDDF84' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 737, y: 316 },
                    { x: 737, y: 369 },
                    { x: 776, y: 376 },
                    { x: 776, y: 328 },
                ],
            },
            {
                color: { code: '4043', rgb: '#FDDF84' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 808, y: 337 },
                    { x: 837, y: 345 },
                    { x: 837, y: 388 },
                    { x: 808, y: 382 },
                ],
            },
            {
                color: { code: 'C 3401 PG II', rgb: '#AC916B' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 192, y: 380 },
                    { x: 192, y: 414 },
                    { x: 240, y: 413 },
                    { x: 240, y: 491 },
                    { x: 192, y: 491 },
                    { x: 192, y: 534 },
                    { x: 220, y: 528 },
                    { x: 302, y: 521 },
                    { x: 302, y: 396 },
                    { x: 592, y: 379 },
                    { x: 843, y: 415 },
                    { x: 843, y: 395 },
                    { x: 592, y: 348 },

                ],
            },
            {
                color: { code: 'C 3470 PG III', rgb: '#838984' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 303, y: 397 },
                    { x: 303, y: 520 },
                    { x: 349, y: 519 },
                    { x: 349, y: 400 },
                    { x: 631, y: 385 },
                    { x: 592, y: 379 },
                ],
            },
        ],
        image: 'assets/domy/dom3_w_zgodzie_z_natura.jpg'
    },
    {
        layers: [
            //  dom4 jasnozielony lewy
            {
                color: { code: 'C 3382 PG II', rgb: '#CECAB4' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 211, y: 208 },
                        { x: 274, y: 201 },
                        { x: 272, y: 410 },
                        { x: 213, y: 409 },
                        { x: 213, y: 353 },
                        { x: 210, y: 347 },
                        { x: 207, y: 344 },
                        { x: 208, y: 271 },
                    ]
                ],
                points: [
                    { x: 161, y: 155 },
                    { x: 340, y: 127 },
                    { x: 340, y: 180 },
                    { x: 345, y: 183 },
                    { x: 345, y: 376 },
                    { x: 340, y: 378 },
                    { x: 340, y: 458 },
                    { x: 162, y: 453 },
                ]
            },

            //dom4 gora jasnozielony
            {
                color: { code: 'C 3382 PG II', rgb: '#CECAB4' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 498, y: 239 },
                    { x: 493, y: 239 },
                    { x: 492, y: 174 },
                    { x: 612, y: 162 },
                    { x: 635, y: 174 },
                    { x: 636, y: 112 },
                    { x: 725, y: 182 },
                    { x: 726, y: 232 },
                    { x: 712, y: 223 },
                    { x: 719, y: 222 },
                    { x: 716, y: 220 },
                    { x: 704, y: 222 },
                    { x: 688, y: 215 },
                    { x: 688, y: 250 },
                    { x: 636, y: 254 },
                    { x: 635, y: 242 },
                    { x: 627, y: 237 },
                    { x: 628, y: 176 },
                    { x: 607, y: 168 },
                    { x: 498, y: 178 },

                ]
            },

            //dom4 srodek bezowy
            {
                color: { code: 'C 3402 PG II', rgb: '#C2A986' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 340, y: 99 },
                    { x: 467, y: 80 },
                    { x: 511, y: 105 },
                    { x: 492, y: 109 },
                    { x: 494, y: 335 },
                    { x: 520, y: 338 },
                    { x: 521, y: 458 },
                    { x: 484, y: 464 },
                    { x: 483, y: 475 },
                    { x: 467, y: 477 },
                    { x: 429, y: 477 },
                    { x: 427, y: 459 },
                    { x: 418, y: 461 },
                    { x: 418, y: 478 },
                    { x: 341, y: 474 },
                    { x: 340, y: 378 },
                    { x: 427, y: 377 },
                    { x: 425, y: 171 },
                    { x: 340, y: 182 },

                ]
            },


            //dom4 dodatkowy bezowy
            {
                color: { code: 'C 3402 PG II', rgb: '#C2A986' },
                selected: false, name: null, opacity: 80,
                cuts: [
                    [
                        { x: 618, y: 365 },
                        { x: 629, y: 365 },
                        { x: 628, y: 374 },
                        { x: 618, y: 374 },
                    ],
                    [
                        { x: 619, y: 401 },
                        { x: 628, y: 401 },
                        { x: 620, y: 410 },
                        { x: 619, y: 410 },
                    ],
                    [
                        { x: 619, y: 435 },
                        { x: 628, y: 435 },
                        { x: 628, y: 446 },
                        { x: 619, y: 446 },
                    ]

                ],
                points: [
                    { x: 608, y: 351 },
                    { x: 642, y: 348 },
                    { x: 644, y: 461 },
                    { x: 607, y: 461 },
                ]
            },

            //dom4 bok brazowy
            {
                color: { code: 'C 3410 PG III', rgb: '#8C6C56' },
                selected: false, name: null, opacity: 80,
                cuts: [],
                points: [
                    { x: 543, y: 353 },
                    { x: 544, y: 458 },
                    { x: 520, y: 458 },
                    { x: 520, y: 338 },
                    { x: 602, y: 335 },
                    { x: 610, y: 337 },
                    { x: 636, y: 338 },
                    { x: 635, y: 304 },
                    { x: 816, y: 294 },
                    { x: 853, y: 318 },
                    { x: 854, y: 451 },
                    { x: 855, y: 464 },
                    { x: 819, y: 477 },
                    { x: 807, y: 477 },
                    { x: 805, y: 464 },
                    { x: 814, y: 458 },
                    { x: 805, y: 458 },
                    { x: 801, y: 452 },
                    { x: 798, y: 458 },
                    { x: 795, y: 465 },
                    { x: 773, y: 465 },
                    { x: 773, y: 345 },
                ]
            },
        ],
        image: 'assets/domy/dom4_w_zgodzie_z_natura.jpg'
    },
];

export const KnaufProjectSets: KnaufProjectSet = {
    // [KnaufPalettes.TopDesign]: TopDesign,
    [KnaufPalettes.MiejskiSzyk]: MiejskiSzyk,
    [KnaufPalettes.KlasycznaElegancja]: KlasycznaElegancja,
    [KnaufPalettes.SwiatoweInspiracje]: SwiatoweInspiracje,
    [KnaufPalettes.WZgodzieZNatura]: WZgodzieZNatura,
    [KnaufPalettes.WszystkieKolory]: null,
    [KnaufPalettes.invalid]: null,
};
